import { createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
var _hoisted_1 = {
  class: "edu-student-item"
};
var _hoisted_2 = {
  class: "student-head"
};
var _hoisted_3 = {
  class: "head-title"
};
import Avatar from './Avatar.vue';
import AcceptRecords from './AcceptRecords.vue';
export default {
  __name: 'StudentItem',
  props: {
    item: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  emits: ['weekMore', 'add'],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var emit = __emit;
    return function (_ctx, _cache) {
      var _props$item;
      var _component_svg_icon = _resolveComponent("svg-icon");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "avatar-box"
      }, null, -1)), _createVNode(Avatar, {
        avatarUrl: __props.item.avatar
      }, null, 8, ["avatarUrl"]), _createElementVNode("h3", _hoisted_3, _toDisplayString(__props.item.userName), 1), _createElementVNode("div", {
        class: "add-evaluate",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return emit('add', __props.item);
        })
      }, [_createVNode(_component_svg_icon, {
        name: "eva-add"
      }), _cache[2] || (_cache[2] = _createElementVNode("span", {
        style: {
          "margin-left": "5px"
        }
      }, "验收", -1))])]), _createVNode(AcceptRecords, {
        weeks: (_props$item = __props.item) === null || _props$item === void 0 ? void 0 : _props$item.userGradeView,
        onWeekMore: _cache[1] || (_cache[1] = function ($event) {
          return emit('weekMore', __props.item);
        })
      }, null, 8, ["weeks"])]);
    };
  }
};